module.exports = __webpack_public_path__ + "img/location.904cccef.svg";